import { useState, useEffect } from 'react';
import { LocalStorage, KEYS } from '@/utils/LocalStorage';
import { User } from '@viome/viome-base/src/usecase/Login/Login.model';

const loginInfoMemo = {
  providerID: '',
  providerKey: '',
};

const userMemo = {
  firstName: '',
  lastName: '',
  shopifyUserID: 0,
  countryPhoneCode: '',
  phiHash: '',
  loginInfo: loginInfoMemo,
  isDentist: false,
  fullName: '',
  userID: '',
  birthDate: 0,
  email: '',
};

export const useUserDetails = (): User => {
  const [userState, setUserState] = useState<User>(userMemo);

  useEffect(() => {
    const localStorageUser = LocalStorage.getItem(KEYS.USER);
    if (localStorageUser) {
      try {
        const parsedUserState = JSON.parse(localStorageUser);
        setUserState(parsedUserState.data);
      } catch (error) {
        console.error(
          'Failed to parse bootup state from local storage:',
          error,
        );
      }
    }
  }, []);

  return userState;
};
